import {
    GET_REFUND_ORDER,
    RE_SUBMIT_REFUND,
} from './refund.actionsTypes';

export default function refund(state = {}, action) {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case GET_REFUND_ORDER:
            return {
                ...newState,
                list: action.payload || [],
            };
        case RE_SUBMIT_REFUND:
            let list = newState.list.map(e => {
                if(e.orderId == action.payload){
                    e.isRefunded = true
                }
                return e
            })
            return {
                ...newState,
                list
            };
        default:
            return newState;
        }
}